import {Component, Input, OnInit} from '@angular/core';
import {Bonus, BonusStatus, BonusType, Contract, User} from '../../../../models';
import {DataStore} from '@aws-amplify/datastore';
import {SessionService} from '../../../services/session.service';
import {ModalController} from '@ionic/angular';

@Component({
    selector: 'app-extend-contract-modal',
    templateUrl: './extend-contract-modal.component.html',
    styleUrls: ['./extend-contract-modal.component.scss'],
})
export class ExtendContractModalComponent implements OnInit {
    @Input() contractId: string;
    contract: Contract;
    years: number = 0;
    newEndDate: Date;
    importo: any;
    max: any;
    dateValue: string;
    loading: boolean = false;
    client: any;
    clientName = '';

    constructor(private sessionService: SessionService, private modalController: ModalController) {
    }

    async ngOnInit() {
        this.contract = await DataStore.query(Contract, this.contractId);
        
        this.importo = this.max = this.contract.amount;
        this.client = await DataStore.query(User, this.contract.clientId);
        
        this.clientName = this.client?.name + ' ' + this.client?.lastname;
        


    }

    counter(number: number) {
        return new Array(number);
    }

    calaculatEndDate() {
        this.newEndDate = new Date(this.contract.endDate);


        this.newEndDate.setFullYear(this.newEndDate.getFullYear() + this.years);
        this.dateValue = this.dateToAwsString(this.newEndDate);
        
        
    }

    dateToAwsString(d) {
        return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    }


    async salva() {
        this.loading = true;

        try {
            await DataStore.save(Contract.copyOf(this.contract, up => {
                up.extended = true;
                up.endDate = this.dateValue;
                up.extendedFromDate = this.contract.endDate;
                up.extendedBy = this.sessionService.getCurrentUser().name + ' ';
                this.sessionService.getCurrentUser().lastname;
                up.extendedTimeStamp = new Date().toISOString();
            }));
        } catch (e) {
            
        }

        for (let i = 0; i < this.years; i++) {
            await DataStore.save(new Bonus({
                contractId: this.contractId,
                type: BonusType.MARKETING_FEE_1,
                total: this.contract.bonusRecurrence,
                status: BonusStatus.NON_PAGATO,
                user:this.contract.commercial
                //userBonusId: this.contract.userContractsAddedId,
            }));
        }
        this.modalController.dismiss();

    }
}
